import React, { Component } from 'react'
import './Footer.scss'

export default class Footer extends Component {
    render() {
        return (
            <footer>
                <div className="footer-wrapper">
                    <a href="https://z.ynet.co.il/short/content/2018/privacypolicy/terms.html" title="" target="_blank">
                        תנאי שימוש
                    </a>{" "}
                    |{" "}
                    <a href="https://z.ynet.co.il/short/content/2018/privacypolicy/policy.html" title="" target="_blank">
                        מדיניות פרטיות
                    </a>{" "}
                    {" "}
                </div>
            </footer>
        )
    }
}
